import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { I18N_DEFAULT_LANGUAGE, I18N_SUPPORTED_LANGUAGES } from './shared/constants/operationals';
import { DialogService } from './core/dialog.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(
    private translate: TranslateService,
    private dialog_service: DialogService,
    private dialog: MatDialog
  ) { 
    this.dialog_service.dialog = this.dialog;
    this.translate.setDefaultLang(I18N_DEFAULT_LANGUAGE);
    const browser_lang: string | undefined = this.translate.getBrowserLang();
    if (browser_lang) this.setBrowserLang(browser_lang);
  }
  
  setBrowserLang(browser_lang: string): void {
    this.translate.use(I18N_SUPPORTED_LANGUAGES.includes(browser_lang) ? browser_lang : I18N_DEFAULT_LANGUAGE);
  }
}
